"use client";
import "../../../chunk-MMUBH76A.js";
const createWalletSlice = (set) => ({
  rpcUrl: void 0,
  setRpcUrl: (rpcUrl) => set({ rpcUrl }),
  selectedWalletId: void 0,
  selectedWalletType: void 0,
  setSelectedWallet: (selectedWalletId, selectedWalletType) => set({ selectedWalletId, selectedWalletType }),
  clearSelectedWallet: () => set({ selectedWalletId: void 0, selectedWalletType: void 0 })
});
export {
  createWalletSlice
};
